/** The potential states of the job. */
enum JobStatus {
  Created = "Created",
  Queued = "Queued",
  Started = "Started",
  Finished = "Finished",
  Failed = "Failed",
  Canceled = "Canceled",
}

export {
  JobStatus
};